import CommunityPage from "../community/CommunityPage";
import CreateDiary from "../community/CreateDiary";

export default function Community() {
  return (
    <>
      <CommunityPage />
      <CreateDiary />
    </>
  );
}
